<template>
  <e-modal
    :visible="visible"
    :title="title"
    :width="500"
    :loading="loading"
    @close="onClose"
    @ok="onSubmit((e) => onSubmitFun(e))"
  >
    <a-spin tip="Loading..." :spinning="loading">
      <a-form>
        <e-input
          title="标题"
          :validate="validateInfos.name"
          v-model:value="modelRef.name"
        />

        <e-cascader title="上级分类" :options="categorys" v-model:value="parentIds" />

        <a-row style="padding-left: 2px">
          <a-col :span="7" :offset="1">
            <e-input-number
              title="顺序"
              v-model:value="modelRef.sortNum"
            />
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </e-modal>
</template>

<script>
import { defineComponent, ref, reactive, toRaw } from 'vue'
import { Form } from 'ant-design-vue'
import form from '@/mixins/form'
import { NewsTypeClass } from '@/apis/news'
import { dataToCascader, getParentIdArray } from '@/utils'

const useForm = Form.useForm
const api = new NewsTypeClass()
export default defineComponent({
  mixins: [form],
  emits: ['ok'],
  components: {},
  props: {
    storeId: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const loading = ref(false)
    const visible = ref(false)
    const isEdit = ref(false)
    const title = ref('')
    const categorys = ref([])
    const parentIds = ref([])

    const modelRef = reactive(api.modelRef)
    const rulesRef = reactive(api.rulesRef)

    const { resetFields, validate, validateInfos } = useForm(
      modelRef,
      rulesRef
    )

    const onClose = () => {
      resetFields()
      parentIds.value = []
      loading.value = false
      visible.value = false
    }

    const filter = (inputValue, path) => {
      return path.some(
        (option) =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      )
    }

    return {
      title,
      visible,
      loading,
      categorys,
      parentIds,
      isEdit,
      modelRef,
      validateInfos,
      resetFields,
      validate,
      onClose,
      filter
    }
  },

  methods: {
    open (formData) {
      if (formData) {
        this.modelRef.name = formData.name
        this.modelRef.parentId = formData.parentId
        this.modelRef.sortNum = formData.sortNum
        this.modelRef.id = formData.id

        this.title = '编辑：' + formData.name
        this.isEdit = true
      } else {
        this.modelRef = reactive(api.modelRef)
        this.title = '添加分类'
        this.isEdit = false
      }

      this.getCategorys()
      this.visible = true
    },

    onSubmitFun (e) {
      const data = toRaw(e)
      const pid = this.parentIds[this.parentIds.length - 1]
      data.parentId = pid || 0

      if (this.isEdit) {
        if (data.parentId === data.id) {
          this.$message.error('逻辑错误')
          this.loading = false
          return false
        }
        api.update(data).then(() => {
          this.loading = false
          this.$message.success('编辑成功')
          this.$emit('ok', null)
          this.onClose()
        })
      } else {
        delete data.id
        api.create(data).then(() => {
          this.loading = false
          this.$message.success('添加成功')
          this.$emit('ok', null)
          this.onClose()
        })
      }
    },

    async getCategorys () {
      const list =
        this.$store.state.data.ALL_NEWTYPES.length > 0
          ? this.$store.state.data.ALL_NEWTYPES
          : await this.$store.dispatch('GetAllNewsTypes')

      this.categorys = dataToCascader(list, 0, 'name')

      if (this.isEdit) {
        const parentIds = getParentIdArray(toRaw(list), this.modelRef.id)
        parentIds.sort((a, b) => a - b)
        this.parentIds = parentIds.filter((x) => x > 0).filter(x => x !== this.modelRef.id)
      }
    }
  }
})
</script>

<style lang="less" scoped>
</style>
